import Vue from 'vue'
import HighchartsVue from 'highcharts-vue'
import Highcharts from 'highcharts'
import loadDrillDown from 'highcharts/modules/drilldown'

loadDrillDown(Highcharts)
Vue.use(HighchartsVue, { Highcharts })
